import React from 'react'
import styled from 'styled-components'

export const Chart = ({
  children,
  update,
  title,
  sub,
  source,
  footnote
}: {
  children?: React.ReactChild
  update?: string
  title?: string
  sub?: string
  footnote?: string | React.ReactChild
  source?: string | React.ReactChild
}) => {
  return (
    <StyledChart className='Chart'>
      {update && <div className='updatenote'>{update}</div>}
      <div className='titlewrapper'>
        {title && <div className='title'>{title}</div>}
        {sub && <div className='sub'>{sub}</div>}
      </div>
      <div className='chart'>{children && children}</div>
      {(footnote || source) && <div className='spacer' />}
      {footnote && <div className='source'>{footnote}</div>}
      {source && <div className='source'>{source}</div>}
    </StyledChart>
  )
}


const StyledChart=styled.div`

display: inline-block;
  font-family: var(--chart-font-stack);
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  font-size: 15px;
  padding-right: 1em;
  // margin-top: 30px;
  // margin-bottom: 3em;

  button.basic {
    border: 0;
    width: 100%;
    color: #fff;
    font-size: 18px;
    background-color: #202346;
    min-height: 56px;
    min-width: 48px;
    max-width: 256px;
    width: 256px;
    max-height: 56px;
    margin-left: auto;
    margin-right: auto;
    @media only screen and (max-width: 711px) {
      width: 100%;
    }
  }
  @media only screen and (max-width: 711px) {
    padding-right: 0em;
  }
  .titlewrapper {
    margin-bottom: 30px;
  }
  .title {
    flex: 0 0 100%;
    text-align: left;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.5em;
  }
  .sub {
    flex: 0 0 100%;
    text-align: left;
    font-size: 15px;
    font-weight: 200;
    line-height: 1.4em;
    margin-bottom: 15px;
  }
  .chart {
    max-width: 100%;
    flex: 0 1 100%;
    display: flex;
    gap: 15px;
  }
  .updatenote {
    background-color: #f0f0f2;
    display: inline-block;
    font-size: 12px;
    letter-spacing: 0.2px;
    font-family: var(--chart-font-stack);
    color: #6f7187;
    margin-top: 1em;
    margin-bottom: 1em;
    padding: 0.25em 0.5em;
  }
  .spacer {
    flex: 0 0 100%;
    display: inline-block;
    width: 100%;
    height: 1em;
  }
  .source,
  .footnote {
    text-align: left;
    flex: 0 0 100%;
    font-size: 12px;
    font-weight: 200;
    line-height: 1.2em !important;

    color: #9698a8;
  }
  `